import React from 'react';
import { bool, func, node, string } from 'prop-types';

import clsx from 'clsx';

import BobConfirmButton from './BobConfirmButton';
import BobCancelButton from './BobCancelButton';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import HtmlTooltip from '../components/HtmlTooltip/HtmlTooltip';

import classes from './BobModal.module.css';

const BobModal = ({
    cancelable,
    applyHidden,
    subTitle,
    rootClass,
    bodyOverride,
    className,
    confirmText,
    cancelText,
    disableBackdropClick = false,
    disableEscapeKeyDown = false,
    disabled,
    hasDatePicker,
    headerOverride,
    hidebuttons,
    isLoading,
    isOnlyContent = false,
    isRemoveFooter = false,
    modalMaxWidth = 960,
    modalBodyStyle,
    onClose,
    onConfirm,
    open,
    children,
    showToolTips,
    title,
    ...props
}) => {

    return (
        <React.Fragment>
            <style>
                {
                    `.MuiDialog-paperWidthMd {
                        max-width: ${modalMaxWidth}px !important;
                    }
                    `
                }
            </style>
            <Dialog
                aria-labelledby="modal-title"
                onClose={onClose}
                open={true}
                maxWidth={'md'}
                className={`${classes.BobModalContainer} ${rootClass? rootClass : ''}`}
                disableBackdropClick={disableBackdropClick}
                disableEscapeKeyDown={disableEscapeKeyDown}
            >
                { isOnlyContent ?
                    <div className={classes.BobModalForExport}>
                        <DialogContent
                            classes={{
                                root: classes.contentContainer
                            }}
                        >
                            <div className={classes.BodyContainer}>
                                {children}
                            </div>
                        </DialogContent>
                    </div> 
                    :
                    <div className={`${rootClass==='conditional-modal'?classes.AnnouncementModal:''} ${classes.BobModal} ${isRemoveFooter ? classes.BobModalWithoutFooter : ''} ${bodyOverride} ${hasDatePicker? classes.WithDatePicker : ''}`}>
                        <DialogTitle
                            classes={{
                                root: clsx(classes.HeaderContainer, headerOverride)
                            }}
                            disableTypography
                        >
                            {subTitle ? <span> {`${title}`} <span style={{ marginLeft: 15, fontWeight: 400, fontSize: 14 }}>{`${subTitle}`}</span></span> : <React.Fragment>{title}</React.Fragment>}
                            {cancelable ?
                                showToolTips ?
                                    <HtmlTooltip
                                        information={'Close'}
                                        placement={'top-start'}
                                        body={
                                            <IconButton
                                                aria-label="Close"
                                                classes={{
                                                    root: classes.CloseButton
                                                }}
                                                color="inherit"
                                                onClick={onClose}
                                            >
                                                <i className="fa fa-times" />
                                            </IconButton>
                                        }
                                    />
                                    :
                                    <IconButton
                                        aria-label="Close"
                                        classes={{
                                            root: classes.CloseButton
                                        }}
                                        color="inherit"
                                        onClick={onClose}
                                    >
                                        <i className="fa fa-times" />
                                    </IconButton>
                                :
                                null}
                        </DialogTitle>
                        <DialogContent
                            classes={{
                                root: classes.dialogContent
                            }}
                        >
                            <div className={clsx(classes.BodyContainer, modalBodyStyle)}>
                                {children}
                            </div>
                        </DialogContent>
                        {
                            !hidebuttons &&
                            <DialogActions
                                classes={{
                                    root: classes.FooterContainer
                                }}
                            >
                                <BobConfirmButton
                                    disabled={disabled}
                                    isLoading={isLoading}
                                    hidden={applyHidden}
                                    label={confirmText}
                                    onClick={onConfirm}
                                />
                                <BobCancelButton
                                    label={cancelText}
                                    hidden={!cancelable}
                                    cancel={onClose}
                                />
                            </DialogActions>
                        }
                    </div>
                }
            </Dialog>
        </React.Fragment>
    );
};

BobModal.defaultProps = {
    cancelable:  true,
    confirmText: 'Confirm',
    cancelText:  'Cancel',
    disabled:    false,
    onClose:     () => { },
    onConfirm:   () => { }
};

BobModal.propTypes = {
    cancelable:  bool,
    children:    node,
    confirmText: string,
    disabled:    bool,
    isLoading:   bool,
    onClose:     func,
    onConfirm:   func,
    open:        bool,
    onRendered:  func,
    title:       string.isRequired
};

export default BobModal;
